import { Select } from '@round/creatorbase-ui';
import { AverageDraftTimeOption, maxAverageDraftTimeOptions } from '../../utils/creatorSearchUtils';
import selectStyles from './selectFilterStyles.module.css';

type Props = {
    value: AverageDraftTimeOption | undefined;
    onChange: (value: AverageDraftTimeOption | undefined) => void;
};

const anyOption = { label: 'Any', value: 'ANY' };

export const AverageDraftTimeFilter = ({ value, onChange }: Props) => {
    return (
        <Select
            className={selectStyles.trigger}
            contentClassName={selectStyles.content}
            options={[
                anyOption,
                ...maxAverageDraftTimeOptions.map((opt) => ({ label: opt.label, value: String(opt.value) })),
            ]}
            value={value ? String(value.value) : undefined}
            onChange={(option) => {
                if (option === 'ANY') {
                    onChange(undefined);
                }
                onChange(maxAverageDraftTimeOptions.find((opt) => String(opt.value) === option));
            }}
            placeholder="Any"
        />
    );
};
